// АНИМ.1: типы для глитч-системы переходов между экранами.
//
// 3 варианта (по описанию README §4 пакета анимаций 1):
//   - soft         — 300мс, без RGB-split, для под-модалок (deck editor и т.п.)
//   - glitch       — 600мс, RGB ±6px, default для большинства переходов
//   - heavy_glitch — 700мс, RGB ±12px + pixel-sort полосы, для входа/выхода
//                    из боя и матчмейкинга
//
// Фазы:
//   idle      — переход не активен (default)
//   outgoing  — старый экран уходит (scale up + fade out + RGB)
//   middle    — чёрный кадр с noise (только glitch/heavy_glitch)
//   incoming  — новый экран приходит (scale up from 0.98 + fade in + RGB inv.)

export type TransitionVariant = 'soft' | 'glitch' | 'heavy_glitch';
export type TransitionPhase = 'idle' | 'outgoing' | 'middle' | 'incoming';

export interface VariantTiming {
  out: number;       // длительность outgoing в мс
  mid: number;       // длительность middle в мс; 0 = пропустить middle
  in: number;        // длительность incoming в мс
  rgbMax: number;    // максимальный сдвиг RGB-split в px (для отображения)
  pixelSort: boolean;
}

export const VARIANT_TIMINGS: Record<TransitionVariant, VariantTiming> = {
  soft:         { out: 150, mid:   0, in: 150, rgbMax:  0, pixelSort: false },
  glitch:       { out: 250, mid: 100, in: 250, rgbMax:  6, pixelSort: false },
  heavy_glitch: { out: 300, mid: 100, in: 300, rgbMax: 12, pixelSort: true  }
};

// Все возможные CSS-классы (для очистки в TransitionOverlay).
export const ALL_TX_CLASSES = [
  'tx-outgoing-soft', 'tx-outgoing-glitch', 'tx-outgoing-heavy_glitch',
  'tx-middle-soft', 'tx-middle-glitch', 'tx-middle-heavy_glitch',
  'tx-incoming-soft', 'tx-incoming-glitch', 'tx-incoming-heavy_glitch'
];
